{
  "version": 1,
  "asset_id": "0135efc5-ae0e-426c-9db1-02bef44e6c54",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/0135efc5-ae0e-426c-9db1-02bef44e6c54/hiatal-type-2-v2-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/0135efc5-ae0e-426c-9db1-02bef44e6c54/hiatal-type-2-v2-800.jpg",
  "original_filename": "hiatal-type-2-v2-800.jpg",
  "size": 82544,
  "content_type": "image/jpeg",
  "created_at": "2026-09-24T19:25:19Z"
}
